import baseAPI from '@/http'

const router = 'api/configuracao'

export const configuracoesAPI = {
    update: (configuracao) => baseAPI.put(router, configuracao),
    get: () => baseAPI.get(`${router}`),
}

